// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"131":"common/tiptap/TiptapEditorDriver","933":"common/components/TiptapMenu"}[chunkId] + ".js";
};